import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Link from '../Link';

const StyledSeriesCount = styled(Link)`
  align-self: center;
  color: ${(props) => props.theme.colors.grayscale.black};
  display: inline-block;
  margin-left: 1em;
  position: relative;
  text-decoration: none;

  :focus,
  :hover {
    cursor: pointer;

    span:first-child {
      background-color: ${(props) => props.theme.colors.grayscale.black};
    }
  }
`;

const StyledCounter = styled.span`
  ${(props) => props.theme.typography.bodySmall}
  align-items: center;
  background-color: ${(props) => props.theme.colors.grayscale.black};
  box-sizing: border-box;
  color: ${(props) => props.theme.colors.grayscale.white};
  display: inline-flex;
  height: 2rem;
  justify-content: center;
  min-width: 2rem;
  padding: 0 0.4rem;
`;

const StyledSpan = styled.span`
  ${(props) => props.theme.typography.body}
  align-items: center;
  display: inline-flex;
  height: 100%;
  justify-content: center;
  padding: 0 0.5rem;
`;

/**
 * Renders a component to display the amount of series
 * credits of a rider. Also functions as a link.
 */
function SeriesCount({ id, count, text, linkWrapper, url, ...rest }) {
  return (
    <StyledSeriesCount
      id={id}
      aria-label={`Series. ${count} credits available.`}
      href={url}
      LinkWrapper={linkWrapper}
      {...rest}
    >
      <StyledCounter id={`${id}-counter`}>{count}</StyledCounter>
      {text ? <StyledSpan id={`${id}-text`}>{text}</StyledSpan> : null}
    </StyledSeriesCount>
  );
}

/**
 * propTypes for this component
 */
SeriesCount.propTypes = {
  /** Amount of series credits available */
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** component id */
  id: PropTypes.string,
  /** LinkWrapper for the Link component */
  linkWrapper: PropTypes.func,
  /** URL for the link */
  url: PropTypes.string,
  /** text to display along with the series counter */
  text: PropTypes.string,
};

/**
 * Default propTypes
 */
SeriesCount.defaultProps = {
  count: 0,
  id: 'header-series-count',
  linkWrapper: null,
  url: '/series',
  text: '',
};

/* @component */
export default SeriesCount;
